import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Disable browser scroll restoration globally — every page load (including
// reloads) starts at top so route-mount-time animations like the home-page
// security banner are never clipped by a restored scroll position.
if (typeof window !== 'undefined' && 'scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register Service Worker for PWA / offline support.
//
// Update strategy: when a new SW is detected (e.g. user has the site open
// across a deploy), prompt the new worker to skip the waiting phase so the
// next navigation gets the fresh bundle. Without this, users can stay on
// the old build for hours until they close every tab.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    // Tell the app shell a fresh build is waiting, so it can show the
    // "Update available" banner + red dot (no silent auto-reload).
    const announceUpdate = (reg) => {
      window.__swReg = reg;
      window.dispatchEvent(new CustomEvent('sw-update-available'));
    };

    navigator.serviceWorker.register('/sw.js')
      .then((reg) => {
        console.log('SW registered:', reg.scope);
        reg.update().catch(() => { /* ignore */ });
        // Poll for new builds every 60s so an already-open PWA notices a
        // deploy without the user having to fully close it.
        setInterval(() => reg.update().catch(() => {}), 60_000);

        if (reg.waiting && navigator.serviceWorker.controller) {
          announceUpdate(reg);
        }
        reg.addEventListener('updatefound', () => {
          const installing = reg.installing;
          if (!installing) return;
          installing.addEventListener('statechange', () => {
            // New SW installed while the old one is still controlling the page
            // = an update is ready to apply. Surface it; don't auto-swap.
            if (installing.state === 'installed' && navigator.serviceWorker.controller) {
              announceUpdate(reg);
            }
          });
        });
      })
      .catch((err) => console.log('SW registration failed:', err));

    // The new SW only takes control after the user taps "Update" (which posts
    // SKIP_WAITING). When it does, reload once into the fresh bundle.
    let reloaded = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (reloaded) return;
      reloaded = true;
      window.location.reload();
    });
  });
}
